import { useMsal } from "@azure/msal-react";
import ApprovalIcon from "@mui/icons-material/Approval";
import ConfirmationNumberOutlined from "@mui/icons-material/ConfirmationNumberOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography
} from "@mui/material";
import * as locales from "@mui/material/locale";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ContactByTokenAction, UpdateContactsSsp } from "../../redux/actions/ContactManagement/Contact";
import { DoLogOutAction } from "../../redux/actions/Login/Login";
import { theme } from "../../redux/actions/Theme/Theme";
import { storeAllResponses } from "../../redux/actions/TicketsManagement/TicketsManagement";
import { IState } from "../../redux/reducers/rootReducers";
import ChatBot from "../ChatBot/ChatBot";
import SideDrawer from "../common/sideDrawer";
import darkmodeImg from "./../../assest/icons/menu/darkmode.svg";
import flagIcon from "./../../assest/icons/menu/flag.svg";
import profile from "./../../assest/profile.png";
import CommonStyles from "./../common/CommonStyles";
import { FallbackAvatarForAgent } from "../navbar/sideNavbar/TopNavbar";
console.log("localeslocales", locales);
export interface ITopNavbar {
  classNames?: string;
}

const TopNavbarSSP: React.FC<ITopNavbar> = (props: ITopNavbar) => {
  const { classNames = "" } = props;
  const navigate = useNavigate();
  const toggleTheme = useSelector((state: IState) => state.theme.theme);
  const useStyles = CommonStyles;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loc, setLoc] = useState([] as any);
  const [drawerState, setDrawerState] = useState(false);
  const profileImg = useSelector(
    (state: IState) => state?.agentReducer?.saveProfile
  );
  const currOrganisation = useSelector(
    (state: IState) => state?.ContactsReducer?.loggedContactOrg
  );
  const currContact = useSelector(
    (state: IState) => state?.ContactsReducer?.loggedContact
  );
  const open = Boolean(anchorEl);

  useEffect(() => {
    const temp = Object.keys(locales);
    temp.unshift("enGb");
    setLoc(temp);
  }, [locales]);

  const { instance } = useMsal();
  function LogOut() {
    if (instance.logout) instance.logout();
    dispatch(theme(false));
    localStorage.clear();
    dispatch(DoLogOutAction());
    dispatch(storeAllResponses({}));
    navigate("/");
  }
  function handleClose() {
    setAnchorEl(null);
  }
  const toggleDarkTheme = () => {
    dispatch(theme(!toggleTheme));
    const defaultPreference = JSON.parse(currContact?.contactPreferences?.TicketDashboardFilterValues || "{}");
    const userObj = JSON.parse(JSON.stringify(currContact));
    userObj.contactPreferences = { ...userObj.contactPreferences, TicketDashboardFilterValues:  JSON.stringify({...defaultPreference, theme : toggleTheme ?  "light-mode" : "dark-mode" })};
    dispatch(UpdateContactsSsp(userObj, submitHandlerCB));
    // dispatch(updateAgentPreference("theme", toggleTheme === true ? "light-mode" : "dark-mode"));
    // document.body.classList.toggle('dark-mode')
    //ThemeStatus()
  };
  const submitHandlerCB = () => {
      dispatch(ContactByTokenAction());
  };
  const handleMenu = () => {
    setDrawerState(true);
  };
  const OnCloseDrawer = () => {
    setDrawerState(false);
  };

  return (
    <>
      <div className={`${classes.topBar} ${classNames}`}>
        <Toolbar className="d-flx">
          <div>
            <ListItemText
              primary={
                <Typography
                  variant="h6"
                  className="pageTitle"
                  style={{ fontWeight: 600 }}
                >
                  {/* {intl.get("header.main.title")} */}
                  {/* {currOrganisation.name} */}
                  <span
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    {/* {OrgTitle} */}
                    {currOrganisation?.name}
                  </span>
                  <div className="btnGrp">
                    {/* <IconButton
                      aria-label="Notification"
                      aria-controls="notification"
                      aria-haspopup="true"
                      // onClick={handleMenu}
                      color="inherit"
                    >
                      <InfoIcon />
                    </IconButton> */}
                    {/* <IconButton
                      aria-label="Notification"
                      aria-controls="notification"
                      aria-haspopup="true"
                      //onClick={handleMenu}
                      color="inherit"
                    >
                      <StarBorderIcon />
                    </IconButton> */}
                    <IconButton
                      aria-label="Menu"
                      aria-controls="menu"
                      aria-haspopup="true"
                      onClick={handleMenu}
                      color="inherit"
                      className={"md-none"}
                    >
                      <MenuIcon />
                    </IconButton>
                  </div>
                </Typography>
              }
              secondary={"Self Service Portal"}
            />
          </div>
          <div className="sm-hide topbar-controls">
            <Link to={`/MyProfileSSP`}>
              <IconButton color="inherit">
                {currContact?.profilePicturePath  ? (
                  <img src={currContact?.profilePicturePath} className="proImg" alt="" height={80} />
                ) : (
                  <FallbackAvatarForAgent
                                   src={``}
                                   firstName={currContact?.name}                                 
                                   width={30}
                                   height={30}
                                   borderRadius="50%"
                                   fontSize="12px"
                                 />
                   )}
              </IconButton>
            </Link>
            <ChatBot /> 
            <IconButton onClick={toggleDarkTheme} color="inherit">
              <img src={darkmodeImg} alt="" />
            </IconButton>
            <Link to={`/Preferences`}>
            <IconButton color="inherit">
              {/* <img src={preferencesIcon} height={20} alt="" />*/}
              <span className="simple-icon icon-equalizer"></span>
            </IconButton>
          </Link>

            <IconButton
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event: any) => {
                setAnchorEl(event.currentTarget);
              }}
              color="inherit"
            >
              <img className="flagImg" src={flagIcon} alt="" />
            </IconButton>
            <Menu
              id="basic-menu"
              sx={{ height: 300 }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {loc?.map((item: any) => {
                return (
                  <MenuItem
                    onClick={(ele: any) => {
                      let temp = `${item.substring(0, 2)}-${item.substring(
                        2,
                        4
                      )}`;
                      console.log("clicked lang", temp);
                      localStorage.setItem("lang", temp);
                      moment.locale(temp);
                      handleClose();
                    }}
                  >
                    {item.substring(0, 2)}-{item.substring(2, 4)}
                  </MenuItem>
                );
              })}
            </Menu>
            {/* <Link to={`/MyTaskApproval`}>
            <IconButton color="inherit" className="notificationIcon">
              <img src={ticketsIcon} alt="" />
              <span className="count">0</span>
            </IconButton>
            </Link> */}
{/* 
            <IconButton
              className="logoutBtn"
              color="inherit"
              onClick={Filterdrawer}
            >
              <ChatOutlinedIcon />
            </IconButton> */}

            <IconButton className="logoutBtn" color="inherit" onClick={LogOut}>
              <LogoutOutlinedIcon />
            </IconButton>
          </div>
        </Toolbar>
      </div>

      <SideDrawer
        onClose={OnCloseDrawer}
        drawerState={drawerState}
        title={"Menu"}
      >
        <>
          <List>
            <Link onClick={OnCloseDrawer} to="/" className={`icon-sidemenu`}>
              <ListItem>
                <ListItemIcon id="homeIcon">
                  <HomeOutlinedIcon />
                  <span> Home</span>
                </ListItemIcon>
              </ListItem>
            </Link>
            <Link
              onClick={OnCloseDrawer}
              to="/addNew"
              className={`icon-sidemenu`}
            >
              <ListItem>
                <ListItemIcon id="newTicIcon">
                  <ConfirmationNumberOutlined />
                  <span> New Ticket</span>
                </ListItemIcon>
              </ListItem>
            </Link>
            <Link
              onClick={OnCloseDrawer}
              to="/myApproval"
              className={`icon-sidemenu`}
            >
              <ListItem>
                <ListItemIcon id="newTicIcon">
                  <ApprovalIcon />
                  <span> My Approval</span>
                </ListItemIcon>
              </ListItem>
            </Link>
          </List>
          <Divider />
          <Box className={`md-none ${classes.sideLogoutBtn}`} onClick={LogOut}>
            <LogoutOutlinedIcon />
            <span> logout</span>
          </Box>
        </>
      </SideDrawer>
    </>
  );
};

export default TopNavbarSSP;
